module.exports = __webpack_public_path__ + "static/media/dot.a463300e.svg";